export const DrawDirection = {
    LEFT: 0,
    RIGHT: 1,
}

export default DrawDirection;
